var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOpen)?_c('div',{staticClass:"account-menu dropdown-menu",on:{"click":function($event){$event.stopPropagation();}}},[_c('h6',{staticClass:"dropdown-header"},[_vm._v(_vm._s(_vm.userFullName))]),_c('a',{staticClass:"dropdown-item",on:{"click":_vm.doLogout}},[_vm._v(" Log out ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }